import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';

export const ButtonProgress = styled(CircularProgress)`
  position: absolute;
`;
